import styled from 'styled-components';

export const InputRow = styled.div`
  padding-bottom: 24px;
  &:after {
    display: block;
    content: '';
    clear: both; 
  }
`;

export default InputRow;
